import { Component, Input } from '@angular/core';

@Component({ standalone: false, selector: 'app-two-columns-forms',
  templateUrl: './two-columns-forms.component.html',
  styleUrls: ['./two-columns-forms.component.scss']
})
export class TwoColumnsFormsComponent {
  @Input()
  secondPageContent: any = false;


}
